import { Component, HostListener, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { fromEvent, Subject } from 'rxjs';
import { debounceTime, filter, takeUntil } from 'rxjs/operators';

import { BarVerticalStackedComponent } from '@swimlane/ngx-charts';

@Component({
  selector: 'stacked-vertical-bar',
  templateUrl: './stacked-vertical-bar.component.html',
  styleUrls: ['./stacked-vertical-bar.component.scss']
})
export class StackedVerticalBarComponent implements OnInit, OnDestroy {
  @Input()
  public readonly isLoading: boolean;

  @Input()
  public readonly data: any[];

  @ViewChild(BarVerticalStackedComponent, { static: false })
  public chart: BarVerticalStackedComponent;

  private readonly subscriptions = new Subject<void>();
  public readonly colors = ['#fc3868', '#24b787'];
  public barPadding = 30;

  ngOnInit(): void {
    const navbar = document.querySelector('fce-sidebar');

    fromEvent(navbar, 'toggleSidebar')
    .pipe(takeUntil(this.subscriptions), debounceTime(100), filter(() => !!this.chart))
    .subscribe(() => this.chart.update());
  }

  ngOnDestroy(): void {
    this.subscriptions.next();
    this.subscriptions.complete();
  }

  public toIntegerAxis(value: number | string): string {
    return Number(value).toPrecision();
  }

  @HostListener('window:beforeprint')
  public async beforePrint(): Promise<void> {
    if (!this.chart) {
      return;
    }

    this.barPadding = 10;
    this.chart.animations = false;
    this.chart.view = [600, 340];
    this.chart.update();
  }

  @HostListener('window:afterprint')
  public async afterPrint(): Promise<void> {
    if (!this.chart) {
      return;
    }

    this.barPadding = 30;
    this.chart.animations = true;
    this.chart.view = null;
    this.chart.update();
  }
}
